import { PremiumIcon, TooltipWrapper } from "@memorang/ui";
import { Chip, type ChipProps } from "react-native-paper";

type Props = {
	tooltip: string;
	text: string;
	mode: ChipProps["mode"];
	isPremium?: boolean;
	icon?: string;
};

export const PremiumChip = ({
	tooltip,
	text,
	mode,
	isPremium = true,
	icon,
}: Props) => {
	return (
		<TooltipWrapper title={tooltip}>
			<Chip
				compact
				icon={isPremium ? () => <PremiumIcon size={16} /> : icon}
				style={{
					alignSelf: "center",
				}}
				mode={mode}
			>
				{text}
			</Chip>
		</TooltipWrapper>
	);
};
